import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import 'rxjs/add/operator/map';
import {BaseService} from "../base-service";
import { Storage } from '@ionic/storage';
import {userSetting} from "../../models/userSetting";
import {Observable} from "rxjs/Observable";
import {AppConfig} from "../../config/appconfig";
import {IWorkRestModesReportParameters} from "../../models/reports/i-work-rest-modes-report-parameters";

/*
  Generated class for the UserSettingsProvider provider.

  See https://angular.    updateUserSettings(arg0: any): any {
        throw new Error("Method not implemented.");
    }
io/docs/ts/latest/guide/dependency-injection.html
  for more info on providers and Angular 2 DI.
*/
@Injectable()
export class UserSettingsProvider extends BaseService{
  saveSettingsUrl: string = AppConfig.apiBaseUrl + "SaveSettings";
  userSettingsUrl: string = AppConfig.apiBaseUrl + "Settings";

  constructor(
    public http: Http,
    public storage: Storage
  ) {
    super(http, storage);
    storage.clear();
  }


  public getSettings() : Promise<userSetting[]>{
    return new Promise<userSetting[]>( (resolve, reject) => {
        let settings : userSetting[] = null;

        this.getuserSettingsFromCache().subscribe(cacheSettings =>{
          if(cacheSettings && cacheSettings.length >0){
            settings = cacheSettings;
            return resolve(settings);
          }
          else {
            this.getuserSettingsFromServer().subscribe(serverSettings =>{
              this.storage.set("userSettings", serverSettings)
                .then(
                  () => {
                    settings = serverSettings;
                    return resolve(settings);
                  }).catch(
                err => {
                  console.log(err);
                  return resolve(settings);
                }
              );
            },err => {
              console.log(err);
              return reject(err);
            });
          }
        },err => {
          console.log(err);
          return reject(err);
        });
    } );
  }

  private getuserSettingsFromCache(): Observable<userSetting[]>{
    return new Observable<userSetting[]>(observer => {
      this.storage.get("userSettings")
        .then(userSettings => {
          observer.next(userSettings);
          observer.complete();
        })
        .catch(err => {
          console.log(err);
          observer.error(err);
        })
    });
  }

  private getuserSettingsFromServer(): Observable<userSetting[]>{
    return this.http.get(
      this.userSettingsUrl,
      {headers: this.headers}
    )
      .map((res:Response) =>
      {
        let r = this.prepareData(res);
        return r.data;
      });
  }

  public updateUserSettings(result: any) : Observable<boolean>{
    return this.http.post(
      this.saveSettingsUrl,
      result,
      {headers: this.headers}
    )
      .map((res:Response) =>
      {
        this.storage.clear();
        return true;
      });
  }
}



// WEBPACK FOOTER //
// ./src/providers/user-settings/user-settings.ts